export const CUSTOMER_TYPES = [
  { id: 0, data: 'Customer' },
  { id: 1, data: 'Operator' },
] as const

export const TABLE_MAX_HEIGHT = 100 * 5
